export const BANNER_IMAGE_URL = 'https://images.unsplash.com/photo-1590015084352-064ebaae567f?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w4MjcwNDJ8MHwxfHNlYXJjaHwxfHxob21lJTIwZGVjb3IlMjBiYW5uZXIlMjBhZXN0aGV0aWMlMjBtb2Rlcm58ZW58MHwwfHx8MTc2Mjc1MjQ3MXww&ixlib=rb-4.1.0&q=80&w=1080';

export const PRODUCTS_PER_PAGE = 20;
